import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

// Reuse the exact schemas from get-product-family-with-inventory to match frontend data structure
const ProductAttributeDefinitionSchema_ = z.object({
  id: z.string(),
  name: z.string(),
  display_name: z.string(),
  product_discriminator: z.boolean(),
  values: z.array(z.string()),
});
export const ProductAttributeDefinitionSchema: z.ZodType<ProductAttributeDefinition> =
  ProductAttributeDefinitionSchema_;
export interface ProductAttributeDefinition
  extends z.infer<typeof ProductAttributeDefinitionSchema_> {}

const ProductAttributeSchema_ = z.object({
  id: z.string().optional(),
  tempId: z.string().optional(),
  value: z.string(),
  definition_id: z.string(),
});
export const ProductAttributeSchema: z.ZodType<ProductAttribute> =
  ProductAttributeSchema_;
export interface ProductAttribute
  extends z.infer<typeof ProductAttributeSchema_> {}

const ProductFamilyAttributeWithDefinitionSchema_ = z.object({
  id: z.string().optional(),
  tempId: z.string().optional(),
  value: z.string().nullable(),
  definition: ProductAttributeDefinitionSchema,
});
export const ProductFamilyAttributeWithDefinitionSchema: z.ZodType<ProductFamilyAttributeWithDefinition> =
  ProductFamilyAttributeWithDefinitionSchema_;
export interface ProductFamilyAttributeWithDefinition
  extends z.infer<typeof ProductFamilyAttributeWithDefinitionSchema_> {}

const ProductImageSchema_ = z.object({
  id: z.string().optional(),
  url: z.string(),
  alt_text: z.string().optional(),
  position: z.number(),
});
export const ProductImageSchema: z.ZodType<ProductImage> = ProductImageSchema_;
export interface ProductImage extends z.infer<typeof ProductImageSchema_> {}

const PopulatedProductSchema_ = z.object({
  id: z.string().optional(),
  tempId: z.string().optional(),
  title: z.string(),
  description: z.string(),
  vendor: z.string().nullish(),
  price: z.number().nullish(),
  sku: z.string().nullish(),
  upc: z.string().nullish(),
  barcodes: z.array(z.string()).default([]),
  attributes: z.array(ProductAttributeSchema).default([]),
  quantity: z.number(),
  images: z.array(ProductImageSchema).default([]),
});
export const PopulatedProductSchema: z.ZodType<PopulatedProduct> =
  PopulatedProductSchema_;
export interface PopulatedProduct
  extends z.infer<typeof PopulatedProductSchema_> {}

// Schema that exactly mirrors the frontend input.value structure
const ProductFamilyFromFrontendSchema_ = z.object({
  name: z.string(),
  vendor: z.string(),
  category: z.string(),
  owner: z.string(),
  images: z.array(ProductImageSchema),
  attributes: z.array(ProductFamilyAttributeWithDefinitionSchema),
  variants: z.array(PopulatedProductSchema),
});
export const ProductFamilyFromFrontendSchema: z.ZodType<ProductFamilyFromFrontend> =
  ProductFamilyFromFrontendSchema_;
export interface ProductFamilyFromFrontend
  extends z.infer<typeof ProductFamilyFromFrontendSchema_> {}

export const upsertProductFamilyAndInventoryAtLocation = unaryRpc({
  name: "upsertProductFamilyAndInventoryAtLocation" as const,
  input: z.object({
    location: z.string(),
    productFamily: ProductFamilyFromFrontendSchema,
    productFamilyId: z.string().optional(), // For editing existing product families
  }),
  output: z.object({ productFamilyId: z.string().optional() }),
});
